var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { loading } from '../../../elements/Loading';
import { Table } from '../../../components';
import history from 'helpers/History';
import { inject } from 'mobx-react';
import { T } from '../../../helpers/i18n';
var MoneysTable = /** @class */ (function (_super) {
    __extends(MoneysTable, _super);
    function MoneysTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/moneys/".concat(value.id));
        };
        _this.handleOnCreate = function () {
            history.push('/moneys/create');
        };
        return _this;
    }
    MoneysTable.prototype.render = function () {
        var data = this.props.store.moneysStore.data.map(function (item) {
            var temp = item;
            temp.primary = item.primary ? 'Si' : item.primary;
            temp.web = item.web ? 'Si' : item.web;
            temp.secondary = item.secondary ? T('yes') : item.secondary;
            temp.customed = item.customed ? T('yes') : item.customed;
            return temp;
        });
        var loaded = this.props.store.moneysStore.loaded;
        var headers = ['alphabeticCode', 'numericCode', 'currency', 'primary', 'web', 'secondary', 'customed'];
        var filters = [
            {
                name: 'all',
                filter: function (item) { return item; }
            },
            {
                name: 'primary',
                filter: function (item) { return item.primary; }
            },
            {
                name: 'web',
                filter: function (item) { return item.web; }
            },
            {
                name: 'secondary',
                filter: function (item) { return item.secondary; }
            },
            {
                name: 'customed',
                filter: function (item) { return item.customed; }
            },
        ];
        return (React.createElement(Table, { keyExtractor: function (item) { return String(item.id); }, items: data, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleOnCreate, loading: !loaded, filters: filters }));
    };
    MoneysTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.moneysStore.read()
            ];
        })
    ], MoneysTable);
    return MoneysTable;
}(Component));
export default MoneysTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/containers/MoneysTable.tsx
// module id = 1598
// module chunks = 0